module.exports = __webpack_public_path__ + "static/penthouse-869c6493def693c7960dfa1933447d26.jpg";